import { SITE_URL } from './seo';

export type BreadcrumbItem = {
  name: string;
  /**
   * Absolute URL or a site-relative path (e.g. "/features").
   */
  item: string;
};

function toAbsoluteUrl(urlOrPath: string) {
  if (urlOrPath.startsWith('http://') || urlOrPath.startsWith('https://')) {
    return urlOrPath;
  }

  if (!urlOrPath.startsWith('/')) return `${SITE_URL}/${urlOrPath}`;
  return `${SITE_URL}${urlOrPath}`;
}

export function buildBreadcrumbList(items: BreadcrumbItem[]) {
  return {
    '@type': 'BreadcrumbList',
    itemListElement: items.map((item, index) => ({
      '@type': 'ListItem',
      position: index + 1,
      name: item.name,
      item: toAbsoluteUrl(item.item),
    })),
  } as const;
}

type FaqInput = {
  q: string;
  text?: string;
  a?: string;
};

export function buildFaqPageSchema(
  faqs: FaqInput[],
  canonical: string,
  options: { includeContext?: boolean } = {},
) {
  return {
    ...(options.includeContext ? { '@context': 'https://schema.org' } : {}),
    '@type': 'FAQPage',
    '@id': `${canonical}#faq`,
    mainEntity: faqs.map((item) => ({
      '@type': 'Question',
      name: item.q,
      acceptedAnswer: {
        '@type': 'Answer',
        text: item.text ?? item.a ?? '',
      },
    })),
  } as const;
}

export function jsonLdStringify(value: unknown) {
  // Escape "<" to prevent breaking out of the inline <script>.
  return JSON.stringify(value).replace(/</g, '\\u003c');
}
